import { get as _get, set as _set, merge as _merge } from 'lodash-es';

export default {
  setPlanId(state, data) {
    state.planId = data;
  },
  initPlan(state, planMeta) {
    state.planMeta = _merge({}, state.planMeta, planMeta);
  },
  setTaskLoading(state, data) {
    state.taskLoading = data;
  },
  setFileListType(state, data) {
    state.fileListType = data;
  },
  updateSearchParams(state, data) {
    state.searchParams = data;
  },
  setAttachmentList(state, data) {
    state.attachmentList = data;
  },
};
